import './youtube.scss'

function onYouTubeIframeAPIReady() {
    document.addEventListener('click', function (e) {
        if (e.target.matches('.js--control-youtube[data-id="<?php echo $youtube_id; ?>"]')) {
            new YT.Player('youtube_<?php echo $youtube_id; ?>', {
                height: '315',
                width: '560',
                videoId: '<?php echo $youtube_id; ?>',
                host: 'https://www.youtube-nocookie.com',
                events: {
                    'onReady': function(event) {
                        event.target.playVideo();
                    }
                }
            });
        }
    });
}

if (typeof YT !== 'undefined' && YT.Player) {
    onYouTubeIframeAPIReady();
}